import React, { useMemo } from 'react';
import { arrayOf, shape, string } from 'prop-types';

import classnames from 'classnames';

import { PACKAGE_NAMESPACE_LABEL } from './constants';
import { getVariablesFromText, getVariablesObject, splitVariablesAndText } from './utils/utilities';
import renderComponentsFromBuilder from './utils/renderComponentsFromBuilder';

const LabelContent = ({ text, content, styles, class_name, id, sourceIcons }) => {
  const NAMESPACE = class_name
    ? `${PACKAGE_NAMESPACE_LABEL}-label-builder ${class_name}`
    : `${PACKAGE_NAMESPACE_LABEL}-label-builder`;

  const result = splitVariablesAndText(text);
  const vars = getVariablesFromText(text);

  const replacements = getVariablesObject(vars, content);

  const componentsToRender = useMemo(
    () => renderComponentsFromBuilder({ result, replacements, sourceIcons }),
    [result, replacements, sourceIcons],
  );

  return (
    <p className={classnames(class_name, NAMESPACE, id)} style={{ ...styles }}>
      {componentsToRender}
    </p>
  );
};

LabelContent.propTypes = {
  class_name: string,
  content: arrayOf(shape({})),
  id: string,
  sourceIcons: shape({}),
  styles: shape({}),
  text: string,
};

export default LabelContent;
